export default __webpack_public_path__ + "static/media/livestock.803b8035.svg";